import React from "react";
import { styled, Stack, Typography } from "@mui/material";

const colors: any = {
  green: "#B1D238",
  blue: "#40A3FF",
  golden: "#CFBD1B",
  platinum: "#D6D6D6",
  silver: "#12121280"
};

const StyledChip = styled(Stack, {
  shouldForwardProp: prop =>
    prop !== "selectedColor" && prop !== "borderPlacement",
  name: "Chip"
})<{
  selectedColor?: string;
  borderPlacement?:
    | "all"
    | "bottom-left"
    | "bottom-right"
    | "top-right"
    | "top-left"
    | undefined;
  theme?: any;
  darkText?: boolean;
}>(({ selectedColor, borderPlacement, darkText, theme }: any) => ({
  backgroundColor: selectedColor ? colors[selectedColor] : colors["green"],
  fontWeight: 600,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textTransform: "capitalize",
  color: darkText ? theme.palette.common.black : theme.palette.common.white,
  height: "fit-content",
  padding: "7px 10px",
  borderRadius:
    borderPlacement === "all"
      ? "20px"
      : `${borderPlacement === "top-left" ? "9px" : 0} ${borderPlacement ===
        "top-right"
          ? "9px"
          : 0} ${borderPlacement === "bottom-right"
          ? "9px"
          : 0} ${borderPlacement === "bottom-left" ? "9px" : 0}`
}));

export interface BadgeVisualInterface {
  color?: string;
  label: string;
  borderPlacement?:
    | "all"
    | "bottom-left"
    | "bottom-right"
    | "top-right"
    | "top-left"
    | undefined;
  darkText?: boolean;
  variant?:
    | "button"
    | "caption"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "inherit"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "overline"
    | undefined;
}

const BadgeVisual: React.FC<BadgeVisualInterface> = ({
  label,
  color = "green",
  borderPlacement = "top-left",
  darkText,
  variant
}: BadgeVisualInterface) => {
  return (
    <StyledChip
      darkText={darkText}
      selectedColor={color}
      borderPlacement={borderPlacement}
      alignItems="center"
      justifyContent="center"
      width="fit-content"
      maxWidth="115px"
      textAlign="center"
    >
      <Typography
        color={darkText ? "black" : "white"}
        variant={variant || "h5"}
        fontWeight={500}
      >
        {label}
      </Typography>
    </StyledChip>
  );
};

export default BadgeVisual;
